import {Box, Grid, Select, SelectOptionItem} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {useQuerySync} from '../../hooks'
import {SelectProps} from '../../types'

type FilterProps = {
  option: SelectProps
  categoryType: SelectProps
  dayType: SelectProps<number>
}

const Filter: React.FC<FilterProps> = ({option, categoryType, dayType}) => {
  const t = useI18n()
  const [selectedOption, setOption] = useQuerySync('option', option.value)
  const [selectedDayType, setDayType] = useQuerySync('day_type', String(dayType.value))
  const [selectedCategoryType, setCategoryType] = useQuerySync('category_type', categoryType.value)

  const handleNameChange = (option: SelectOptionItem | null) => {
    setOption(String(option?.value || ''))
  }
  const handleDayTypeChange = (option: SelectOptionItem<number> | null) => {
    setDayType(String(option?.value || ''))
  }
  const handleCategoryTypeChange = (option: SelectOptionItem | null) => {
    setCategoryType(String(option?.value || ''))
  }

  return (
    <Box pt="l">
      <Grid spacing={2} container>
        {option.options.length > 0 && (
          <Grid xs={6} item>
            <Select onChange={handleNameChange} options={option.options} size="s" value={selectedOption} />
          </Grid>
        )}
        <Grid xs={12} item>
          <Select
            onChange={handleCategoryTypeChange}
            options={categoryType.options}
            placeholder={t('tariffs.filter.category_type')}
            size="s"
            value={selectedCategoryType}
          />
        </Grid>
        <Grid xs={12} item>
          <Select
            onChange={handleDayTypeChange}
            options={dayType.options}
            placeholder={t('tariffs.filter.day_type')}
            size="s"
            value={Number(selectedDayType)}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Filter
